//@flow
import React, { Component, type Node } from 'react';
import { ModelRowTr } from '../../../components/ModelListStyles';
import { CustomSpacerTd } from './TableComponentStyles';

type Props = {
  children: Node,
  className?: string,
  hoverStylesMobile?: boolean,
  hoverStyles?: boolean,
  onClick?: () => void,
  expanded?: boolean,
  highlighted?: boolean
};

export default class DefaultModelRowTr extends Component<Props> {
  render() {
    return (
      <ModelRowTr
        classname={this.props.className}
        hoverStylesMobile={this.props.hoverStylesMobile}
        hoverStyles={this.props.hoverStyles}
        expanded={this.props.expanded}
        highlighted={this.props.highlighted}
        onClick={this.props.onClick}
      >
        <CustomSpacerTd />
        {this.props.children}
        <CustomSpacerTd />
      </ModelRowTr>
    );
  }
}
